var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_626_19923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 0V15H15V0H2.25ZM7.35 12H3.53V1.99615H7.35V12ZM13.73 13.0038H8.63V11.0077H13.73V13.0038ZM13.73 8.50385H8.63V6.50769H13.73V8.50385ZM13.73 4.00385H8.63V1.99615H13.73V3.99231V4.00385Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0.876923H0V15H1.5V0.876923Z",
    fill: "#444444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_19923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNews);
export default __webpack_public_path__ + "static/media/icon_news.ba229d74ce26632cd4f4fdff5f39a03e.svg";
export { ForwardRef as ReactComponent };